( function () {
	'use strict';

	/* @ngInject */
	function createObsService ( Session, apiService, $q, _ ) {
		var self = this;

		var credentials = Session.getCredentials();

		self.preLoadedData = null;

		function getSchoolsAndUsers () {
			var deferred = $q.defer();

			apiService.users.query( {
				'userId' : credentials.userId,
				'rights' : 'create'
			}, function ( res ) {
				if ( res ) {
					deferred.resolve( res );
				}
			}, function ( err ) {
				deferred.reject( err );
			} );

			return deferred.promise;
		}

		function getTemplates () {
			var deferred = $q.defer();

			apiService.templates.query( {
				'userId' : credentials.userId
			}, function ( res ) {
				if ( res ) {
					deferred.resolve( res );
				}
			}, function ( err ) {
				deferred.reject( err );
			} );

			return deferred.promise;
		}

		function getFavoriteTemplates () {
			var deferred = $q.defer();

			apiService.library.query( {
				'userId' : credentials.userId
			}, function ( res ) {
				if ( res ) {
					deferred.resolve( res );
				}
			}, function ( err ) {
				deferred.reject( err );
			} );

			return deferred.promise;
		}

		function saveObservation ( data ) {
			var deferred = $q.defer();

			apiService.observation.save( {
				'userId'      : credentials.userId,
				'observation' : 'observation'
			}, data, function ( res ) {
				if ( res ) {
					deferred.resolve( res );
				}
			}, function ( err ) {
				deferred.reject( err );
			} );

			return deferred.promise;
		}

		function getReorderedTemplates ( arr1, arr2 ) {
			var allTemplates = arr1 || [ ];
			var favTemplates = arr2 || [ ];

			_.map( allTemplates, function ( t ) {
				t.isFav = _.filter( favTemplates, function ( f ) {
					return f.id === t.id;
				} ).length > 0;
			} );

			allTemplates = _.sortBy( allTemplates, function ( t ) {
				return t.isFav;
			} );

			return allTemplates;
		}

		function savePreLoadedData ( promiseData ) {
			var deferred = $q.defer();

			deferred.resolve( [ ] );

			self.preLoadedData  =  promiseData || deferred.promise;
		}

		function getPreLoadedData () {
			return self.preLoadedData;
		}

		var service = {
			'getSchoolsAndUsers'    : getSchoolsAndUsers,
			'getTemplates'          : getTemplates,
			'saveObservation'       : saveObservation,
			'getFavoriteTemplates'  : getFavoriteTemplates,
			'getReorderedTemplates' : getReorderedTemplates,
			'savePreLoadedData'     : savePreLoadedData,
			'getPreLoadedData'      : getPreLoadedData,
			'getInReviewLocations'  : apiService.getInReviewLocations,
			'getObsViewRights'      : apiService.getUsersThatCanProvideFeedback
		};

		return service;
	}

	angular
		.module( 'app.core' )
		.factory( 'createObsService', createObsService );
} )();
